export const FETCH_ALL = "FETCH_ALL";
export const ADD_NEW = "ADD_NEW";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const GET_INVOICE = "GET_INVOICE";
export const GET_ADD_NEW_INVOICE = "GET_ADD_NEW_INVOICE";
export const FETCH_INVOICE_BY_USER = "FETCH_INVOICE_BY_USER";
export const FETCH_INVOICE_BY_RENTALID = "FETCH_INVOICE_BY_RENTALID";
export const UPDATE_INVOICE_ATTACHMENT = "UPDATE_INVOICE_ATTACHMENT";
export const ALL_CLIENTS = "ALL_CLIENTS";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const FETCH_CLIENTS_BY_USER = "FETCH_CLIENTS_BY_USER";
export const FETCH_CLIENTS_BY_SEARCH_QUERY = "FETCH_CLIENTS_BY_SEARCH_QUERY";

export const AUTH = "AUTH";
export const SET_RESOLVED_COMPANY = "SET_RESOLVED_COMPANY";
export const DB_INITIALIZING = "DB_INITIALIZING";
export const DB_READY = "DB_READY";
export const MUST_CHANGE_PASSWORD = "MUST_CHANGE_PASSWORD";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const LOGOUT = "LOGOUT";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const FETCH_CLIENT = "FETCH_CLIENT";

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const CREATE_PROFILE = "CREATE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const FETCH_PROFILES = "FETCH_PROFILES";
export const FETCH_PROFILE = "FETCH_PROFILE";
export const FETCH_PROFILE_BY_USER = "FETCH_PROFILE_USER";
export const FETCH_PROFILES_BY_USER = "FETCH_PROFILES_BY_USER";

export const UPLOAD_FILE = "UPLOAD_FILE";
export const FETCH_FILE = "FETCH_FILE";
export const FETCH_FILES_BY_USER = "FETCH_FILES_BY_USER";
export const FETCH_INVOICE_NUMBER = "FETCH_INVOICE_NUMBER";

export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const FETCH_CATEGORY = "FETCH_CATEGORY";
export const FETCH_CATEGORIES_BY_USER = "FETCH_CATEGORIES_BY_USER";

export const CREATE_ITEM = "CREATE_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const FETCH_ITEM = "FETCH_ITEM";
export const FETCH_ITEMS_BY_USER = "FETCH_ITEMS_BY_USER";
export const ITEMS_LAST_MODIFIED_BY_USER = "ITEMS_LAST_MODIFIED_BY_USER";
export const FIND_ITEM_BY_BARCODE = "FIND_ITEM_BY_BARCODE";
export const ITEM_CATEGORY = "ITEM_CATEGORY";

// Excel Import Constants
export const EXCEL_IMPORT_UPLOAD_START = "EXCEL_IMPORT_UPLOAD_START";
export const EXCEL_IMPORT_UPLOAD_SUCCESS = "EXCEL_IMPORT_UPLOAD_SUCCESS";
export const EXCEL_IMPORT_UPLOAD_FAILURE = "EXCEL_IMPORT_UPLOAD_FAILURE";
export const EXCEL_IMPORT_PREVIEW_START = "EXCEL_IMPORT_PREVIEW_START";
export const EXCEL_IMPORT_PREVIEW_SUCCESS = "EXCEL_IMPORT_PREVIEW_SUCCESS";
export const EXCEL_IMPORT_PREVIEW_FAILURE = "EXCEL_IMPORT_PREVIEW_FAILURE";
export const EXCEL_IMPORT_EXECUTE_START = "EXCEL_IMPORT_EXECUTE_START";
export const EXCEL_IMPORT_EXECUTE_SUCCESS = "EXCEL_IMPORT_EXECUTE_SUCCESS";
export const EXCEL_IMPORT_EXECUTE_FAILURE = "EXCEL_IMPORT_EXECUTE_FAILURE";
export const EXCEL_IMPORT_STATUS_UPDATE = "EXCEL_IMPORT_STATUS_UPDATE";
export const EXCEL_IMPORT_PROGRESS_UPDATE = "EXCEL_IMPORT_PROGRESS_UPDATE";
export const EXCEL_IMPORT_COMPLETED = "EXCEL_IMPORT_COMPLETED";
export const EXCEL_IMPORT_CANCELLED = "EXCEL_IMPORT_CANCELLED";
export const EXCEL_IMPORT_HISTORY_FETCH_START = "EXCEL_IMPORT_HISTORY_FETCH_START";
export const EXCEL_IMPORT_HISTORY_FETCH_SUCCESS = "EXCEL_IMPORT_HISTORY_FETCH_SUCCESS";
export const EXCEL_IMPORT_HISTORY_FETCH_FAILURE = "EXCEL_IMPORT_HISTORY_FETCH_FAILURE";
export const EXCEL_IMPORT_TEMPLATES_FETCH_START = "EXCEL_IMPORT_TEMPLATES_FETCH_START";
export const EXCEL_IMPORT_TEMPLATES_FETCH_SUCCESS = "EXCEL_IMPORT_TEMPLATES_FETCH_SUCCESS";
export const EXCEL_IMPORT_TEMPLATES_FETCH_FAILURE = "EXCEL_IMPORT_TEMPLATES_FETCH_FAILURE";
export const EXCEL_IMPORT_TEMPLATE_SAVE_START = "EXCEL_IMPORT_TEMPLATE_SAVE_START";
export const EXCEL_IMPORT_TEMPLATE_SAVE_SUCCESS = "EXCEL_IMPORT_TEMPLATE_SAVE_SUCCESS";
export const EXCEL_IMPORT_TEMPLATE_SAVE_FAILURE = "EXCEL_IMPORT_TEMPLATE_SAVE_FAILURE";
export const EXCEL_IMPORT_FIELDS_FETCH_START = "EXCEL_IMPORT_FIELDS_FETCH_START";
export const EXCEL_IMPORT_FIELDS_FETCH_SUCCESS = "EXCEL_IMPORT_FIELDS_FETCH_SUCCESS";
export const EXCEL_IMPORT_FIELDS_FETCH_FAILURE = "EXCEL_IMPORT_FIELDS_FETCH_FAILURE";
export const EXCEL_IMPORT_SUGGESTIONS_FETCH_START = "EXCEL_IMPORT_SUGGESTIONS_FETCH_START";
export const EXCEL_IMPORT_SUGGESTIONS_FETCH_SUCCESS = "EXCEL_IMPORT_SUGGESTIONS_FETCH_SUCCESS";
export const EXCEL_IMPORT_SUGGESTIONS_FETCH_FAILURE = "EXCEL_IMPORT_SUGGESTIONS_FETCH_FAILURE";
export const EXCEL_IMPORT_VALIDATION_RULES_FETCH_START = "EXCEL_IMPORT_VALIDATION_RULES_FETCH_START";
export const EXCEL_IMPORT_VALIDATION_RULES_FETCH_SUCCESS = "EXCEL_IMPORT_VALIDATION_RULES_FETCH_SUCCESS";
export const EXCEL_IMPORT_VALIDATION_RULES_FETCH_FAILURE = "EXCEL_IMPORT_VALIDATION_RULES_FETCH_FAILURE";
export const EXCEL_IMPORT_AUDIT_LOGS_FETCH_START = "EXCEL_IMPORT_AUDIT_LOGS_FETCH_START";
export const EXCEL_IMPORT_AUDIT_LOGS_FETCH_SUCCESS = "EXCEL_IMPORT_AUDIT_LOGS_FETCH_SUCCESS";
export const EXCEL_IMPORT_AUDIT_LOGS_FETCH_FAILURE = "EXCEL_IMPORT_AUDIT_LOGS_FETCH_FAILURE";
export const EXCEL_IMPORT_RESET_STATE = "EXCEL_IMPORT_RESET_STATE";
export const EXCEL_IMPORT_SET_CURRENT_STEP = "EXCEL_IMPORT_SET_CURRENT_STEP";
export const EXCEL_IMPORT_UPDATE_MAPPING = "EXCEL_IMPORT_UPDATE_MAPPING";
export const EXCEL_IMPORT_UPDATE_OPTIONS = "EXCEL_IMPORT_UPDATE_OPTIONS";

// Excel Export Constants
export const EXCEL_EXPORT_FIELDS_FETCH_START = "EXCEL_EXPORT_FIELDS_FETCH_START";
export const EXCEL_EXPORT_FIELDS_FETCH_SUCCESS = "EXCEL_EXPORT_FIELDS_FETCH_SUCCESS";
export const EXCEL_EXPORT_FIELDS_FETCH_FAILURE = "EXCEL_EXPORT_FIELDS_FETCH_FAILURE";
export const EXCEL_EXPORT_PREVIEW_START = "EXCEL_EXPORT_PREVIEW_START";
export const EXCEL_EXPORT_PREVIEW_SUCCESS = "EXCEL_EXPORT_PREVIEW_SUCCESS";
export const EXCEL_EXPORT_PREVIEW_FAILURE = "EXCEL_EXPORT_PREVIEW_FAILURE";
export const EXCEL_EXPORT_GENERATE_START = "EXCEL_EXPORT_GENERATE_START";
export const EXCEL_EXPORT_GENERATE_SUCCESS = "EXCEL_EXPORT_GENERATE_SUCCESS";
export const EXCEL_EXPORT_GENERATE_FAILURE = "EXCEL_EXPORT_GENERATE_FAILURE";
export const EXCEL_EXPORT_DOWNLOAD_START = "EXCEL_EXPORT_DOWNLOAD_START";
export const EXCEL_EXPORT_DOWNLOAD_SUCCESS = "EXCEL_EXPORT_DOWNLOAD_SUCCESS";
export const EXCEL_EXPORT_DOWNLOAD_FAILURE = "EXCEL_EXPORT_DOWNLOAD_FAILURE";
export const EXCEL_EXPORT_HISTORY_FETCH_START = "EXCEL_EXPORT_HISTORY_FETCH_START";
export const EXCEL_EXPORT_HISTORY_FETCH_SUCCESS = "EXCEL_EXPORT_HISTORY_FETCH_SUCCESS";
export const EXCEL_EXPORT_HISTORY_FETCH_FAILURE = "EXCEL_EXPORT_HISTORY_FETCH_FAILURE";
export const EXCEL_EXPORT_STATISTICS_FETCH_START = "EXCEL_EXPORT_STATISTICS_FETCH_START";
export const EXCEL_EXPORT_STATISTICS_FETCH_SUCCESS = "EXCEL_EXPORT_STATISTICS_FETCH_SUCCESS";
export const EXCEL_EXPORT_STATISTICS_FETCH_FAILURE = "EXCEL_EXPORT_STATISTICS_FETCH_FAILURE";
export const EXCEL_EXPORT_RESET_STATE = "EXCEL_EXPORT_RESET_STATE";
export const EXCEL_EXPORT_SET_CURRENT_STEP = "EXCEL_EXPORT_SET_CURRENT_STEP";
export const EXCEL_EXPORT_UPDATE_FIELDS = "EXCEL_EXPORT_UPDATE_FIELDS";
export const EXCEL_EXPORT_UPDATE_FILTERS = "EXCEL_EXPORT_UPDATE_FILTERS";
export const EXCEL_EXPORT_UPDATE_OPTIONS = "EXCEL_EXPORT_UPDATE_OPTIONS";
export const ADD_NEW_RECEIPT = "ADD_NEW_RECEIPT";

// Website-identity cache (read-only). Legacy CREATE/UPDATE/DELETE/list/check
// constants removed during the company-model decommission.
export const FETCH_COMPANY = "FETCH_COMPANY";
export const FETCH_COMPANY_PUBLIC_DETAILS = "FETCH_COMPANY_PUBLIC_DETAILS";

// Per-tenant ERP-local profile (logo, footer, default notes, ZATCA, etc.)
export const COMPANY_PROFILE_LOADING = "COMPANY_PROFILE_LOADING";
export const COMPANY_PROFILE_FETCH = "COMPANY_PROFILE_FETCH";
export const COMPANY_PROFILE_ERROR = "COMPANY_PROFILE_ERROR";

export const CREATE_USER_GROUP = "CREATE_USER_GROUP";
export const UPDATE_USER_GROUP = "UPDATE_USER_GROUP";
export const DELETE_USER_GROUP = "DELETE_USER_GROUP";
export const FETCH_USER_GROUP = "FETCH_USER_GROUP";
export const FETCH_USER_GROUPS = "FETCH_USER_GROUPS";
export const FETCH_ROLES = "FETCH_ROLES";
export const SEED_DEFAULT_USER_GROUPS = "SEED_DEFAULT_USER_GROUPS";

export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USERS = "FETCH_USERS";
export const DOWNLOAD_PDF_INVOICE = "DOWNLOAD_PDF_INVOICE";
export const EMAIL_INVOICE = "EMAIL_INVOICE";
export const paymentMethods = [
  {
    title: "Credit",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  { title: "Cash", paidAmount: 0, note: "", date: new Date().toLocaleString() },
  {
    title: "Transfer",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Check",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "PayPal",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Bank",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Debit Card",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Mobile Payment",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
  {
    title: "Others",
    paidAmount: 0,
    note: "",
    date: new Date().toLocaleString(),
  },
];

export const paymentDirections = [
  { value: "in", label: "Inbound Payment" },
  { value: "out", label: "Outbound Payment" },
];

export const paymentSources = [
  { value: "invoice", label: "Invoice" },
  { value: "payroll", label: "Payroll" },
  { value: "rental", label: "Rental" },
  { value: "other", label: "Other" },
];

export const ADD_UNIT = "CREATE_UNIT";
export const UPDATE_UNIT = "UPDATE_UNIT";
export const DELETE_UNIT = "DELETE_UNIT";
export const FETCH_UNITS = "FETCH_UNITS";
export const FETCH_UNIT = "FETCH_UNIT";

export const FETCH_RENTALS = "FETCH_RENTALS";
export const FETCH_UNPAID_RENTALS = "FETCH_UNPAID_RENTALS";
export const FETCH_RENTAL = "FETCH_RENTAL";
export const ADD_RENTAL = "ADD_RENTAL";
export const UPDATE_RENTAL = "UPDATE_RENTAL";
export const DELETE_RENTAL = "DELETE_RENTAL";

export const ADD_BUILDING = "CREATE_BUILDING";
export const UPDATE_BUILDING = "UPDATE_BUILDING";
export const DELETE_BUILDING = "DELETE_BUILDING";
export const FETCH_BUILDINGS = "FETCH_BUILDINGS";
export const FETCH_BUILDING = "FETCH_BUILDING";

export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const FETCH_TRANSACTIONS = "FETCH_TRANSACTIONS";
export const FETCH_TRANSACTION = "FETCH_TRANSACTION";

export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const FETCH_ACCOUNTS = "FETCH_ACCOUNTS";
export const FETCH_ACCOUNT = "FETCH_ACCOUNT";

// Profit Centers Constants
export const FETCH_PROFIT_CENTERS = "FETCH_PROFIT_CENTERS";
export const FETCH_PROFIT_CENTER = "FETCH_PROFIT_CENTER";
export const ADD_PROFIT_CENTER = "ADD_PROFIT_CENTER";
export const UPDATE_PROFIT_CENTER = "UPDATE_PROFIT_CENTER";
export const DELETE_PROFIT_CENTER = "DELETE_PROFIT_CENTER";
export const PROFIT_CENTERS_ERROR = "PROFIT_CENTERS_ERROR";

export const ADD_LETTER = "ADD_LETTER";
export const UPDATE_LETTER = "UPDATE_LETTER";
export const DELETE_LETTER = "DELETE_LETTER";
export const FETCH_LETTERS = "FETCH_LETTERS";
export const FETCH_LETTER = "FETCH_LETTER";
export const CLEAR_CURRENT_LETTER = "CLEAR_CURRENT_LETTER";

export const SEED_ACCOUNT = "SEED_ACCOUNT";
export const FETCH_TRIAL_BALANCE = "FETCH_TRIAL_BALANCE";
export const FETCH_BALANCE_SHEET = "FETCH_BALANCE_SHEET";
export const FETCH_CASH_FLOW = "FETCH_CASH_FLOW";
export const FETCH_GENERAL_LEDGER = "FETCH_GENERAL_LEDGER";
export const FETCH_AGING_REPORT = "FETCH_AGING_REPORT";
export const FETCH_ACCOUNT_STATEMENT = "FETCH_ACCOUNT_STATEMENT";
export const FETCH_VAT_REPORT = "FETCH_VAT_REPORT";

export const ADD_PURCHASE_INVOICE = "ADD_PURCHASE_INVOICE";
export const UPDATE_PURCHASE_INVOICE = "UPDATE_PURCHASE_INVOICE";
export const DELETE_PURCHASE_INVOICE = "DELETE_PURCHASE_INVOICE";
export const FETCH_PURCHASE_INVOICES = "FETCH_PURCHASE_INVOICES";
export const FETCH_PURCHASE_INVOICE = "FETCH_PURCHASE_INVOICE";
export const FETCH_LAST_PURCHASE_NUMBER = "FETCH_LAST_PURCHASE_NUMBER";
export const DOWNLOAD_PURCHASE_PDF_INVOICE = "DOWNLOAD_PURCHASE_PDF_INVOICE";
export const EMAIL_PURCHASE_INVOICE = "EMAIL_PURCHASE_INVOICE";
export const CLEAR_CURRENT_PURCHASE_INVOICE = "CLEAR_CURRENT_PURCHASE_INVOICE";

export const CREATE_PAYROLL = "CREATE_PAYROLL";
export const FETCH_PAYROLLS = "FETCH_PAYROLLS";
export const FETCH_PAYROLL_SUMMARY = "FETCH_PAYROLL_SUMMARY";
export const BULK_CREATE_PAYROLL = "BULK_CREATE_PAYROLL";
export const PROCESS_PAYROLL = "PROCESS_PAYROLL";
export const DELETE_PAYROLL = "DELETE_PAYROLL";

export const RECORD_ATTENDANCE = "RECORD_ATTENDANCE";
export const FETCH_ATTENDANCE_RECORDS = "FETCH_ATTENDANCE_RECORDS";

// Modern Attendance Constants
export const FETCH_MODERN_ATTENDANCE_START = "FETCH_MODERN_ATTENDANCE_START";
export const FETCH_MODERN_ATTENDANCE_SUCCESS = "FETCH_MODERN_ATTENDANCE_SUCCESS";
export const FETCH_MODERN_ATTENDANCE_FAIL = "FETCH_MODERN_ATTENDANCE_FAIL";
export const CHECK_IN_START = "CHECK_IN_START";
export const CHECK_IN_SUCCESS = "CHECK_IN_SUCCESS";
export const CHECK_IN_FAIL = "CHECK_IN_FAIL";
export const CHECK_OUT_START = "CHECK_OUT_START";
export const CHECK_OUT_SUCCESS = "CHECK_OUT_SUCCESS";
export const CHECK_OUT_FAIL = "CHECK_OUT_FAIL";
export const CREATE_ATTENDANCE_SUCCESS = "CREATE_ATTENDANCE_SUCCESS";
export const UPDATE_ATTENDANCE_SUCCESS = "UPDATE_ATTENDANCE_SUCCESS";
export const DELETE_ATTENDANCE_SUCCESS = "DELETE_ATTENDANCE_SUCCESS";

// Shift Management Constants
export const FETCH_SHIFTS_START = "FETCH_SHIFTS_START";
export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
export const FETCH_SHIFTS_FAIL = "FETCH_SHIFTS_FAIL";
export const CREATE_SHIFT_SUCCESS = "CREATE_SHIFT_SUCCESS";
export const UPDATE_SHIFT_SUCCESS = "UPDATE_SHIFT_SUCCESS";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";

// Holiday Management Constants
export const FETCH_HOLIDAYS_START = "FETCH_HOLIDAYS_START";
export const FETCH_HOLIDAYS_SUCCESS = "FETCH_HOLIDAYS_SUCCESS";
export const FETCH_HOLIDAYS_FAIL = "FETCH_HOLIDAYS_FAIL";
export const CREATE_HOLIDAY_SUCCESS = "CREATE_HOLIDAY_SUCCESS";
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS";
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS";

// Attendance Configuration Constants
export const FETCH_ATTENDANCE_CONFIG_START = "FETCH_ATTENDANCE_CONFIG_START";
export const FETCH_ATTENDANCE_CONFIG_SUCCESS = "FETCH_ATTENDANCE_CONFIG_SUCCESS";
export const FETCH_ATTENDANCE_CONFIG_FAIL = "FETCH_ATTENDANCE_CONFIG_FAIL";
export const UPDATE_ATTENDANCE_CONFIG_SUCCESS = "UPDATE_ATTENDANCE_CONFIG_SUCCESS";

// SMS Settings
export const FETCH_SMS_SETTINGS = "FETCH_SMS_SETTINGS";
export const UPDATE_SMS_SETTINGS = "UPDATE_SMS_SETTINGS";

// Barcode Settings
export const FETCH_BARCODE_SETTINGS = "FETCH_BARCODE_SETTINGS";
export const FETCH_BARCODE_SETTING = "FETCH_BARCODE_SETTING";
export const ADD_BARCODE_SETTING = "ADD_BARCODE_SETTING";
export const UPDATE_BARCODE_SETTING = "UPDATE_BARCODE_SETTING";
export const DELETE_BARCODE_SETTING = "DELETE_BARCODE_SETTING";
export const CLEAR_CURRENT_BARCODE_SETTING = "CLEAR_CURRENT_BARCODE_SETTING";

// Tax Settings Types
export const FETCH_All_TAX_SETTINGS = "FETCH_All_TAX_SETTINGS";
export const FETCH_TAX_SETTINGS_BY_ID = "FETCH_TAX_SETTINGS_BY_ID";
export const CREATE_TAX_SETTINGS = "CREATE_TAX_SETTINGS";
export const UPDATE_TAX_SETTINGS = "UPDATE_TAX_SETTINGS";
export const DELETE_TAX_SETTINGS = "DELETE_TAX_SETTINGS";

//Costcenters
export const FETCH_COST_CENTERS = "FETCH_COST_CENTERS";
export const FETCH_COST_CENTER = "FETCH_COST_CENTER";
export const ADD_COST_CENTER = "ADD_COST_CENTER";
export const UPDATE_COST_CENTER = "UPDATE_COST_CENTER";
export const DELETE_COST_CENTER = "DELETE_COST_CENTER";
export const COST_CENTERS_ERROR = "COST_CENTERS_ERROR";

// projects
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PROJECT = "FETCH_PROJECT";
export const ADD_PROJECT = "ADD_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const PROJECTS_ERROR = "PROJECTS_ERROR";

// Assets Types
export const FETCH_ASSETS = "FETCH_ASSETS";
export const FETCH_ASSET = "FETCH_ASSET";
export const ADD_ASSET = "ADD_ASSET";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const DELETE_ASSET = "DELETE_ASSET";

// SMS Providers Types
export const FETCH_SMS_PROVIDERS = "FETCH_SMS_PROVIDERS";
export const FETCH_SMS_PROVIDER = "FETCH_SMS_PROVIDER";
export const ADD_SMS_PROVIDER = "ADD_SMS_PROVIDER";
export const UPDATE_SMS_PROVIDER = "UPDATE_SMS_PROVIDER";
export const SMS_PROVIDERS_ERROR = "SMS_PROVIDERS_ERROR";
export const DELETE_SMS_PROVIDER = "DELETE_SMS_PROVIDER";

// Notification Constants
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";

// Coupons
export const FETCH_COUPONS = "FETCH_COUPONS";
export const FETCH_COUPON = "FETCH_COUPON";
export const FETCH_COUPON_BY_CODE = "FETCH_COUPON_BY_CODE";
export const CREATE_COUPON = "CREATE_COUPON";
export const UPDATE_COUPON = "UPDATE_COUPON";
export const DELETE_COUPON = "DELETE_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";

// Vouchers
export const CREATE_VOUCHERS = "CREATE_VOUCHERS";
export const FETCH_VOUCHERS = "FETCH_VOUCHERS";
export const UPDATE_VOUCHERS = "UPDATE_VOUCHERS";
export const USE_VOUCHERS = "USE_VOUCHERS";
export const DELETE_VOUCHERS = "DELETE_VOUCHERS";
export const ERROR_VOUCHERS = "ERROR_VOUCHERS";

// Communication
export const WHATSAPP_LOGIN = "WHATSAPP_LOGIN";
export const WHATSAPP_LOGIN_ERROR = "WHATSAPP_LOGIN_ERROR";
export const SET_SOCKET_CONNECTED = "SET_SOCKET_CONNECTED";
export const SET_SOCKET_DATA = "SET_SOCKET_DATA";
export const SET_SOCKET_ERROR = "SET_SOCKET_ERROR";
export const SET_SOCKET_INSTANCE = "SET_SOCKET_INSTANCE";
export const CONNECT_WHATSAPP = "CONNECT_WHATSAPP";
export const CONNECT_WHATSAPP_ERROR = "CONNECT_WHATSAPP_ERROR";

// WebSocket / Real-time Messaging
export const WEBSOCKET_CONNECT = "WEBSOCKET_CONNECT";
export const WEBSOCKET_DISCONNECT = "WEBSOCKET_DISCONNECT";
export const WEBSOCKET_SEND_MESSAGE = "WEBSOCKET_SEND_MESSAGE";
export const WEBSOCKET_SEND_TYPING = "WEBSOCKET_SEND_TYPING";
export const WEBSOCKET_JOIN_CONVERSATION = "WEBSOCKET_JOIN_CONVERSATION";
export const WEBSOCKET_LEAVE_CONVERSATION = "WEBSOCKET_LEAVE_CONVERSATION";
export const WEBSOCKET_CONNECTION_STATUS = "WEBSOCKET_CONNECTION_STATUS";
export const RECEIVE_MESSAGE = "RECEIVE_MESSAGE";
export const TYPING_INDICATOR = "TYPING_INDICATOR";
export const USER_STATUS_CHANGE = "USER_STATUS_CHANGE";
export const READ_RECEIPT = "READ_RECEIPT";
export const MESSAGE_DELIVERED = "MESSAGE_DELIVERED";
export const MESSAGE_READ = "MESSAGE_READ";
export const UPDATE_UNREAD_COUNT = "UPDATE_UNREAD_COUNT";

// Messaging
export const FETCH_CONVERSATIONS = "FETCH_CONVERSATIONS";
export const FETCH_CONVERSATION = "FETCH_CONVERSATION";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const UPDATE_CONVERSATION = "UPDATE_CONVERSATION";
export const DELETE_CONVERSATION = "DELETE_CONVERSATION";
export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const ADD_PARTICIPANT = "ADD_PARTICIPANT";
export const REMOVE_PARTICIPANT = "REMOVE_PARTICIPANT";
export const FETCH_UNREAD_COUNT = "FETCH_UNREAD_COUNT";
export const MARK_AS_READ = "MARK_AS_READ";
export const UPLOAD_MESSAGE_ATTACHMENT = "UPLOAD_MESSAGE_ATTACHMENT";
export const DELETE_MESSAGE_ATTACHMENT = "DELETE_MESSAGE_ATTACHMENT";
export const MESSAGING_ERROR = "MESSAGING_ERROR";
export const MESSAGING_LOADING = "MESSAGING_LOADING";

// ProductPackages
export const CREATE_PRODUCT_PACKAGE = "CREATE_PRODUCT_PACKAGE";
export const FETCH_PRODUCT_PACKAGES = "FETCH_PRODUCT_PACKAGES";
export const UPDATE_PRODUCT_PACKAGE = "UPDATE_PRODUCT_PACKAGE";
export const PRODUCT_PACKAGE_ERROR = "PRODUCT_PACKAGE_ERROR";
export const FETCH_PRODUCT_PACKAGE = "FETCH_PRODUCT_PACKAGE";
export const DELETE_PRODUCT_PACKAGE = "DELETE_PRODUCT_PACKAGE";
export const FETCH_PRODUCT_PACKAGES_BY_LANG = "FETCH_PRODUCT_PACKAGES_BY_LANG";

// Features
export const FETCH_FEATURES = "FETCH_FEATURES";
export const FETCH_FEATURE_BY_LANG = "FETCH_FEATURE_BY_LANG";
export const CREATE_FEATURE = "CREATE_FEATURE";
export const UPDATE_FEATURE = "UPDATE_FEATURE";
export const DELETE_FEATURE = "DELETE_FEATURE";
export const ERROR_FEATURE = "ERROR_FEATURE";

// Translation
export const TRANSALTE = "TRANSALTE";
export const ERROR_TRANSALTE = "ERROR_TRANSALTE";

// Account Settings
export const FETCH_ACCOUNTING_SETTINGS = "FETCH_ACCOUNTING_SETTINGS";
export const CREATE_ACCOUNTING_SETTINGS = "CREATE_ACCOUNTING_SETTINGS";
export const UPDATE_ACCOUNTING_SETTINGS = "UPDATE_ACCOUNTING_SETTINGS";
export const FETCH_ACCOUNTING_PERIODS = "FETCH_ACCOUNTING_PERIODS";
export const UPDATE_ACCOUNTING_PERIOD = "UPDATE_ACCOUNTING_PERIOD";
export const ACCOUNTING_SETTINGS_ERROR = "ACCOUNTING_SETTINGS_ERROR";

export const FETCH_MANUFACTURING_SETTINGS = "FETCH_MANUFACTURING_SETTINGS";
export const UPDATE_MANUFACTURING_SETTINGS = "UPDATE_MANUFACTURING_SETTINGS";
export const FETCH_MANUFACTURING_PRESETS = "FETCH_MANUFACTURING_PRESETS";
export const FETCH_MANUFACTURING_READINESS = "FETCH_MANUFACTURING_READINESS";
export const MANUFACTURING_ERROR = "MANUFACTURING_ERROR";
export const FETCH_MANUFACTURING_BOMS = "FETCH_MANUFACTURING_BOMS";
export const FETCH_MANUFACTURING_BOM = "FETCH_MANUFACTURING_BOM";
export const CREATE_MANUFACTURING_BOM = "CREATE_MANUFACTURING_BOM";
export const UPDATE_MANUFACTURING_BOM = "UPDATE_MANUFACTURING_BOM";
export const DELETE_MANUFACTURING_BOM = "DELETE_MANUFACTURING_BOM";
export const EXPLODE_MANUFACTURING_BOM = "EXPLODE_MANUFACTURING_BOM";
export const ROLLUP_MANUFACTURING_BOM_COST = "ROLLUP_MANUFACTURING_BOM_COST";
export const FETCH_MANUFACTURING_WORK_CENTERS = "FETCH_MANUFACTURING_WORK_CENTERS";
export const CREATE_MANUFACTURING_WORK_CENTER = "CREATE_MANUFACTURING_WORK_CENTER";
export const UPDATE_MANUFACTURING_WORK_CENTER = "UPDATE_MANUFACTURING_WORK_CENTER";
export const FETCH_MANUFACTURING_WORK_CENTER_CAPACITY = "FETCH_MANUFACTURING_WORK_CENTER_CAPACITY";
export const FETCH_MANUFACTURING_ROUTINGS = "FETCH_MANUFACTURING_ROUTINGS";
export const CREATE_MANUFACTURING_ROUTING = "CREATE_MANUFACTURING_ROUTING";
export const UPDATE_MANUFACTURING_ROUTING = "UPDATE_MANUFACTURING_ROUTING";
export const FETCH_MANUFACTURING_WORK_ORDERS = "FETCH_MANUFACTURING_WORK_ORDERS";
export const FETCH_MANUFACTURING_WORK_ORDER = "FETCH_MANUFACTURING_WORK_ORDER";
export const FETCH_MANUFACTURING_WORK_ORDER_COST = "FETCH_MANUFACTURING_WORK_ORDER_COST";
export const GENERATE_MANUFACTURING_WORK_ORDER_QR_LABEL = "GENERATE_MANUFACTURING_WORK_ORDER_QR_LABEL";
export const GENERATE_MANUFACTURING_WORK_ORDER_LOT_SERIAL_QR_LABELS = "GENERATE_MANUFACTURING_WORK_ORDER_LOT_SERIAL_QR_LABELS";
export const CREATE_MANUFACTURING_WORK_ORDER = "CREATE_MANUFACTURING_WORK_ORDER";
export const UPDATE_MANUFACTURING_WORK_ORDER = "UPDATE_MANUFACTURING_WORK_ORDER";
export const FETCH_MANUFACTURING_QC_TEMPLATES = "FETCH_MANUFACTURING_QC_TEMPLATES";
export const FETCH_MANUFACTURING_QC_TEMPLATE = "FETCH_MANUFACTURING_QC_TEMPLATE";
export const CREATE_MANUFACTURING_QC_TEMPLATE = "CREATE_MANUFACTURING_QC_TEMPLATE";
export const UPDATE_MANUFACTURING_QC_TEMPLATE = "UPDATE_MANUFACTURING_QC_TEMPLATE";
export const FETCH_MANUFACTURING_QC_INSPECTIONS = "FETCH_MANUFACTURING_QC_INSPECTIONS";
export const FETCH_MANUFACTURING_QC_INSPECTION = "FETCH_MANUFACTURING_QC_INSPECTION";
export const FETCH_MANUFACTURING_QC_CERTIFICATE_OF_ANALYSIS = "FETCH_MANUFACTURING_QC_CERTIFICATE_OF_ANALYSIS";
export const FETCH_MANUFACTURING_QC_NON_CONFORMANCES = "FETCH_MANUFACTURING_QC_NON_CONFORMANCES";
export const FETCH_MANUFACTURING_QC_CAPAS = "FETCH_MANUFACTURING_QC_CAPAS";
export const CREATE_MANUFACTURING_QC_NON_CONFORMANCE = "CREATE_MANUFACTURING_QC_NON_CONFORMANCE";
export const UPDATE_MANUFACTURING_QC_NON_CONFORMANCE = "UPDATE_MANUFACTURING_QC_NON_CONFORMANCE";
export const UPDATE_MANUFACTURING_QC_CAPA = "UPDATE_MANUFACTURING_QC_CAPA";
export const CREATE_MANUFACTURING_QC_INSPECTION = "CREATE_MANUFACTURING_QC_INSPECTION";
export const UPDATE_MANUFACTURING_QC_INSPECTION = "UPDATE_MANUFACTURING_QC_INSPECTION";
export const FETCH_MANUFACTURING_PRODUCTION_PLANS = "FETCH_MANUFACTURING_PRODUCTION_PLANS";
export const FETCH_MANUFACTURING_PRODUCTION_PLAN = "FETCH_MANUFACTURING_PRODUCTION_PLAN";
export const CREATE_MANUFACTURING_PRODUCTION_PLAN = "CREATE_MANUFACTURING_PRODUCTION_PLAN";
export const UPDATE_MANUFACTURING_PRODUCTION_PLAN = "UPDATE_MANUFACTURING_PRODUCTION_PLAN";
export const FETCH_MANUFACTURING_PRODUCTION_PLAN_SHORTAGES = "FETCH_MANUFACTURING_PRODUCTION_PLAN_SHORTAGES";
export const FETCH_MANUFACTURING_PRODUCTION_PLAN_CAPACITY = "FETCH_MANUFACTURING_PRODUCTION_PLAN_CAPACITY";
export const FETCH_MANUFACTURING_PRODUCTION_MRP_RUN = "FETCH_MANUFACTURING_PRODUCTION_MRP_RUN";
export const FETCH_MANUFACTURING_SUBCONTRACT_ORDERS = "FETCH_MANUFACTURING_SUBCONTRACT_ORDERS";
export const FETCH_MANUFACTURING_SUBCONTRACT_ORDER = "FETCH_MANUFACTURING_SUBCONTRACT_ORDER";
export const CREATE_MANUFACTURING_SUBCONTRACT_ORDER = "CREATE_MANUFACTURING_SUBCONTRACT_ORDER";
export const UPDATE_MANUFACTURING_SUBCONTRACT_ORDER = "UPDATE_MANUFACTURING_SUBCONTRACT_ORDER";
export const FETCH_MANUFACTURING_MAINTENANCE_REQUESTS = "FETCH_MANUFACTURING_MAINTENANCE_REQUESTS";
export const FETCH_MANUFACTURING_MAINTENANCE_REQUEST = "FETCH_MANUFACTURING_MAINTENANCE_REQUEST";
export const CREATE_MANUFACTURING_MAINTENANCE_REQUEST = "CREATE_MANUFACTURING_MAINTENANCE_REQUEST";
export const UPDATE_MANUFACTURING_MAINTENANCE_REQUEST = "UPDATE_MANUFACTURING_MAINTENANCE_REQUEST";
export const FETCH_MANUFACTURING_WORK_CENTER_OEE = "FETCH_MANUFACTURING_WORK_CENTER_OEE";
export const GENERATE_MANUFACTURING_PREVENTIVE_MAINTENANCE = "GENERATE_MANUFACTURING_PREVENTIVE_MAINTENANCE";
export const FETCH_MANUFACTURING_DASHBOARD_REPORT = "FETCH_MANUFACTURING_DASHBOARD_REPORT";
export const FETCH_MANUFACTURING_PRODUCTION_SUMMARY_REPORT = "FETCH_MANUFACTURING_PRODUCTION_SUMMARY_REPORT";
export const FETCH_MANUFACTURING_WORK_CENTER_UTILIZATION_REPORT = "FETCH_MANUFACTURING_WORK_CENTER_UTILIZATION_REPORT";
export const FETCH_MANUFACTURING_MAINTENANCE_LOG_REPORT = "FETCH_MANUFACTURING_MAINTENANCE_LOG_REPORT";
export const FETCH_MANUFACTURING_MATERIAL_CONSUMPTION_REPORT = "FETCH_MANUFACTURING_MATERIAL_CONSUMPTION_REPORT";
export const FETCH_MANUFACTURING_COST_VARIANCE_REPORT = "FETCH_MANUFACTURING_COST_VARIANCE_REPORT";
export const FETCH_MANUFACTURING_SCRAP_YIELD_REPORT = "FETCH_MANUFACTURING_SCRAP_YIELD_REPORT";
export const FETCH_MANUFACTURING_QC_SUMMARY_REPORT = "FETCH_MANUFACTURING_QC_SUMMARY_REPORT";
export const FETCH_MANUFACTURING_SUBCONTRACTING_STATUS_REPORT = "FETCH_MANUFACTURING_SUBCONTRACTING_STATUS_REPORT";
export const FETCH_MANUFACTURING_WIP_AGING_REPORT = "FETCH_MANUFACTURING_WIP_AGING_REPORT";
export const FETCH_MANUFACTURING_LOT_SERIAL_GENEALOGY_REPORT = "FETCH_MANUFACTURING_LOT_SERIAL_GENEALOGY_REPORT";
export const FETCH_MANUFACTURING_SUBLEDGER_RECONCILIATION_REPORT = "FETCH_MANUFACTURING_SUBLEDGER_RECONCILIATION_REPORT";
export const FETCH_MANUFACTURING_CONTROL_EXCEPTIONS_REPORT = "FETCH_MANUFACTURING_CONTROL_EXCEPTIONS_REPORT";

// Properties
export const FETCH_PROPERTIES = "FETCH_PROPERTIES";
export const FETCH_PROPERTY = "FETCH_PROPERTY";
export const CREATE_PROPERTY = "CREATE_PROPERTY";
export const UPDATE_PROPERTY = "UPDATE_PROPERTY";
export const DELETE_PROPERTY = "DELETE_PROPERTY";
export const ADD_ATTACHMENT = "ADD_ATTACHMENT";
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
export const UPLOAD_MULTIPLE_ATTACHMENTS = "UPLOAD_MULTIPLE_ATTACHMENTS";
export const ERROR_PROPERTY = "ERROR_PROPERTY";
export const ERROR_DELETEING_ATTACHMENT = "ERROR_DELETEING_ATTACHMENT";
export const ERROR_UPLOADING_ATTACHMENTS = "ERROR_UPLOADING_ATTACHMENTS";

export const SEARCH_PROPERTIES = "SEARCH_PROPERTIES";
export const PROPERTY_ERROR = "PROPERTY_ERROR";

// Clinic Management Constants
export const FETCH_DOCTORS = "FETCH_DOCTORS";
export const FETCH_DOCTOR = "FETCH_DOCTOR";
export const CREATE_DOCTOR = "CREATE_DOCTOR";
export const UPDATE_DOCTOR = "UPDATE_DOCTOR";
export const DELETE_DOCTOR = "DELETE_DOCTOR";

export const FETCH_PATIENTS = "FETCH_PATIENTS";
export const FETCH_PATIENT = "FETCH_PATIENT";
export const CREATE_PATIENT = "CREATE_PATIENT";
export const UPDATE_PATIENT = "UPDATE_PATIENT";
export const DELETE_PATIENT = "DELETE_PATIENT";

export const FETCH_APPOINTMENTS = "FETCH_APPOINTMENTS";
export const FETCH_APPOINTMENT = "FETCH_APPOINTMENT";
export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";

// Journal Management
export const FETCH_JOURNALS = "FETCH_JOURNALS";
export const FETCH_JOURNAL = "FETCH_JOURNAL";
export const CREATE_JOURNAL = "CREATE_JOURNAL";
export const UPDATE_JOURNAL = "UPDATE_JOURNAL";
export const DELETE_JOURNAL = "DELETE_JOURNAL";
export const FETCH_JOURNAL_SUMMARY = "FETCH_JOURNAL_SUMMARY";

// Journal Error Handling
export const JOURNALS_ERROR = "JOURNALS_ERROR";
export const CLEAR_JOURNALS_ERROR = "CLEAR_JOURNALS_ERROR";

// Journal Entries
export const FETCH_JOURNAL_ENTRIES = "FETCH_JOURNAL_ENTRIES";

// POS Terminal Constants
export const FETCH_POS_TERMINALS = "FETCH_POS_TERMINALS";
export const FETCH_POS_TERMINAL = "FETCH_POS_TERMINAL";
export const CREATE_POS_TERMINAL = "CREATE_POS_TERMINAL";
export const UPDATE_POS_TERMINAL = "UPDATE_POS_TERMINAL";
export const DELETE_POS_TERMINAL = "DELETE_POS_TERMINAL";

// POS Transaction Constants
export const FETCH_POS_TRANSACTIONS = "FETCH_POS_TRANSACTIONS";
export const FETCH_POS_TRANSACTION = "FETCH_POS_TRANSACTION";
export const CREATE_POS_TRANSACTION = "CREATE_POS_TRANSACTION";
export const ADD_PAYMENT_TO_TRANSACTION = "ADD_PAYMENT_TO_TRANSACTION";
export const REFUND_TRANSACTION = "REFUND_TRANSACTION";
export const VOID_TRANSACTION = "VOID_TRANSACTION";

// POS Reports Constants
export const FETCH_POS_SALES_REPORT = "FETCH_POS_SALES_REPORT";

export const FETCH_JOURNAL_ENTRY = "FETCH_JOURNAL_ENTRY";
export const CREATE_JOURNAL_ENTRY = "CREATE_JOURNAL_ENTRY";
export const UPDATE_JOURNAL_ENTRY = "UPDATE_JOURNAL_ENTRY";
export const DELETE_JOURNAL_ENTRY = "DELETE_JOURNAL_ENTRY";
export const SUBMIT_JOURNAL_ENTRY = "SUBMIT_JOURNAL_ENTRY";
export const APPROVE_JOURNAL_ENTRY = "APPROVE_JOURNAL_ENTRY";
export const POST_JOURNAL_ENTRY = "POST_JOURNAL_ENTRY";
export const REVERSE_JOURNAL_ENTRY = "REVERSE_JOURNAL_ENTRY";
export const BULK_APPROVE_ENTRIES = "BULK_APPROVE_ENTRIES";
export const BULK_POST_ENTRIES = "BULK_POST_ENTRIES";

export const FETCH_LAB_RESULTS = "FETCH_LAB_RESULTS";
export const FETCH_LAB_RESULT = "FETCH_LAB_RESULT";
export const CREATE_LAB_RESULT = "CREATE_LAB_RESULT";
export const UPDATE_LAB_RESULT = "UPDATE_LAB_RESULT";
export const DELETE_LAB_RESULT = "DELETE_LAB_RESULT";

export const FETCH_LAB_TESTS = "FETCH_LAB_TESTS";
export const FETCH_LAB_TEST = "FETCH_LAB_TEST";
export const CREATE_LAB_TEST = "CREATE_LAB_TEST";
export const UPDATE_LAB_TEST = "UPDATE_LAB_TEST";
export const DELETE_LAB_TEST = "DELETE_LAB_TEST";
export const CLEAR_LAB_TEST = "CLEAR_LAB_TEST";

export const FETCH_MEDICAL_RECORDS = "FETCH_MEDICAL_RECORDS";
export const FETCH_MEDICAL_RECORD = "FETCH_MEDICAL_RECORD";
export const CREATE_MEDICAL_RECORD = "CREATE_MEDICAL_RECORD";
export const UPDATE_MEDICAL_RECORD = "UPDATE_MEDICAL_RECORD";
export const DELETE_MEDICAL_RECORD = "DELETE_MEDICAL_RECORD";

export const FETCH_MEDICAL_SERVICES = "FETCH_MEDICAL_SERVICES";
export const FETCH_MEDICAL_SERVICE = "FETCH_MEDICAL_SERVICE";
export const CREATE_MEDICAL_SERVICE = "CREATE_MEDICAL_SERVICE";
export const UPDATE_MEDICAL_SERVICE = "UPDATE_MEDICAL_SERVICE";
export const DELETE_MEDICAL_SERVICE = "DELETE_MEDICAL_SERVICE";

export const FETCH_MEDICATIONS = "FETCH_MEDICATIONS";
export const FETCH_MEDICATION = "FETCH_MEDICATION";
export const CREATE_MEDICATION = "CREATE_MEDICATION";
export const UPDATE_MEDICATION = "UPDATE_MEDICATION";
export const DELETE_MEDICATION = "DELETE_MEDICATION";
export const CLEAR_MEDICATION = "CLEAR_MEDICATION";

export const FETCH_PRESCRIPTIONS = "FETCH_PRESCRIPTIONS";
export const FETCH_PRESCRIPTION = "FETCH_PRESCRIPTION";
export const CREATE_PRESCRIPTION = "CREATE_PRESCRIPTION";
export const UPDATE_PRESCRIPTION = "UPDATE_PRESCRIPTION";
export const DELETE_PRESCRIPTION = "DELETE_PRESCRIPTION";
export const CLEAR_PRESCRIPTION = "CLEAR_PRESCRIPTION";

// Email
export const CREATE_SMTP_CONFIG = "CREATE_SMTP_CONFIG";
export const CREATE_SMTP_TEST = "CREATE_SMTP_TEST";
export const SMTP_ERROR = "SMTP_ERROR";

export const WHATSAPP_LOGOUT = "WHATSAPP_LOGOUT";
export const WHATSAPP_LOGOUT_ERROR = "WHATSAPP_LOGOUT_ERROR";

// Payments
export const FETCH_PAYMENTS = "FETCH_PAYMENTS";
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const FETCH_PAYMENTS_BY_INVOICE = "FETCH_PAYMENTS_BY_INVOICE";
export const FETCH_PAYMENTS_BY_PAYROLL = "FETCH_PAYMENTS_BY_PAYROLL";
export const FETCH_PAYMENTS_BY_RENTAL = "FETCH_PAYMENTS_BY_RENTAL";
export const PRINT_PAYMENT_RECEIPT = "PRINT_PAYMENT_RECEIPT";

// Payroll
export const FETCH_PAYROLL = "FETCH_PAYROLL";
export const UPDATE_PAYROLL = "UPDATE_PAYROLL";

// Payment Methods
export const PAYMENT_METHODS = [
  "CASH",
  "BANK_TRANSFER",
  "CREDIT_CARD",
  "CHECK",
  "PAYPAL",
  "VENMO",
  "OTHER",
];

export const PAYMENT_DIRECTIONS = ["in", "out"];

// Inventory Management
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const FETCH_INVENTORY_ITEM = "FETCH_INVENTORY_ITEM";
export const CREATE_INVENTORY_ITEM = "CREATE_INVENTORY_ITEM";
export const UPDATE_INVENTORY_ITEM = "UPDATE_INVENTORY_ITEM";
export const DELETE_INVENTORY_ITEM = "DELETE_INVENTORY_ITEM";
export const FETCH_PRODUCT_INVENTORY = "FETCH_PRODUCT_INVENTORY";

// Inventory Adjustments
export const FETCH_INVENTORY_ADJUSTMENTS = "FETCH_INVENTORY_ADJUSTMENTS";
export const FETCH_INVENTORY_ADJUSTMENT = "FETCH_INVENTORY_ADJUSTMENT";
export const CREATE_INVENTORY_ADJUSTMENT = "CREATE_INVENTORY_ADJUSTMENT";
export const UPDATE_INVENTORY_ADJUSTMENT = "UPDATE_INVENTORY_ADJUSTMENT";
export const DELETE_INVENTORY_ADJUSTMENT = "DELETE_INVENTORY_ADJUSTMENT";

// Inventory Transactions
export const FETCH_INVENTORY_TRANSACTIONS = "FETCH_INVENTORY_TRANSACTIONS";
export const FETCH_INVENTORY_TRANSACTION = "FETCH_INVENTORY_TRANSACTION";
export const CREATE_INVENTORY_TRANSFER = "CREATE_INVENTORY_TRANSFER";
export const FETCH_INVENTORY_VALUATION = "FETCH_INVENTORY_VALUATION";
export const FETCH_INVENTORY_VALUATION_REPORT = "FETCH_INVENTORY_VALUATION_REPORT";
export const FETCH_INVENTORY_ALERTS = "FETCH_INVENTORY_ALERTS";

// Unit of Measure
export const FETCH_UNIT_OF_MEASURES = "FETCH_UNIT_OF_MEASURES";
export const FETCH_UNIT_OF_MEASURE = "FETCH_UNIT_OF_MEASURE";
export const CREATE_UNIT_OF_MEASURE = "CREATE_UNIT_OF_MEASURE";
export const UPDATE_UNIT_OF_MEASURE = "UPDATE_UNIT_OF_MEASURE";
export const DELETE_UNIT_OF_MEASURE = "DELETE_UNIT_OF_MEASURE";

// Warehouse
export const FETCH_WAREHOUSES = "FETCH_WAREHOUSES";
export const FETCH_WAREHOUSE = "FETCH_WAREHOUSE";
export const CREATE_WAREHOUSE = "CREATE_WAREHOUSE";
export const UPDATE_WAREHOUSE = "UPDATE_WAREHOUSE";
export const DELETE_WAREHOUSE = "DELETE_WAREHOUSE";

// Credit / Debit Notes
export const FETCH_CREDIT_DEBIT_NOTES = "FETCH_CREDIT_DEBIT_NOTES";
export const FETCH_CREDIT_DEBIT_NOTE = "FETCH_CREDIT_DEBIT_NOTE";
export const CREATE_CREDIT_DEBIT_NOTE = "CREATE_CREDIT_DEBIT_NOTE";
export const UPDATE_CREDIT_DEBIT_NOTE = "UPDATE_CREDIT_DEBIT_NOTE";
export const DELETE_CREDIT_DEBIT_NOTE = "DELETE_CREDIT_DEBIT_NOTE";
export const FETCH_CREDIT_DEBIT_NOTE_NUMBER = "FETCH_CREDIT_DEBIT_NOTE_NUMBER";

// Inventory Orders
export const FETCH_INVENTORY_ORDERS   = "FETCH_INVENTORY_ORDERS";
export const FETCH_INVENTORY_ORDER    = "FETCH_INVENTORY_ORDER";
export const FULFIL_INVENTORY_ORDER   = "FULFIL_INVENTORY_ORDER";
export const CANCEL_INVENTORY_ORDER   = "CANCEL_INVENTORY_ORDER";

// Company Settings
export const FETCH_COMPANY_SETTINGS = "FETCH_COMPANY_SETTINGS";
export const UPDATE_COMPANY_SETTINGS = "UPDATE_COMPANY_SETTINGS";

// Product Attributes
export const FETCH_ATTRIBUTES = "FETCH_ATTRIBUTES";
export const FETCH_ATTRIBUTE = "FETCH_ATTRIBUTE";
export const CREATE_ATTRIBUTE = "CREATE_ATTRIBUTE";
export const UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE";
export const DELETE_ATTRIBUTE = "DELETE_ATTRIBUTE";
export const FETCH_ATTRIBUTE_VALUES = "FETCH_ATTRIBUTE_VALUES";
export const FETCH_ATTRIBUTE_VALUE = "FETCH_ATTRIBUTE_VALUE";
export const CREATE_ATTRIBUTE_VALUE = "CREATE_ATTRIBUTE_VALUE";
export const UPDATE_ATTRIBUTE_VALUE = "UPDATE_ATTRIBUTE_VALUE";
export const DELETE_ATTRIBUTE_VALUE = "DELETE_ATTRIBUTE_VALUE";

export const UPDATE_PAYMENT_ATTACHMENT = "UPDATE_PAYMENT_ATTACHMENT";
export const RE_GENERATE_TRANSACTIONS = "RE_GENERATE_TRANSACTIONS";

// To-Do List Constants
export const ADD_TODO_LIST = "ADD_TODO_LIST";
export const UPDATE_TODO_LIST = "UPDATE_TODO_LIST";
export const DELETE_TODO_LIST = "DELETE_TODO_LIST";
export const FETCH_TODO_LISTS = "FETCH_TODO_LISTS";
export const FETCH_TODO_LIST = "FETCH_TODO_LIST";
export const ADD_TODO_ITEM = "ADD_TODO_ITEM";
export const UPDATE_TODO_ITEM = "UPDATE_TODO_ITEM";
export const DELETE_TODO_ITEM = "DELETE_TODO_ITEM";
export const FETCH_TODO_ITEMS = "FETCH_TODO_ITEMS";
export const TOGGLE_TODO_ITEM = "TOGGLE_TODO_ITEM";
export const CLEAR_CURRENT_LIST = "CLEAR_CURRENT_LIST";
